<div class="container">
    <div style="text-align: center;">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="usuario==null"></span>
    </div>
    

    <div class="card shadow-lg border-0 rounded-lg mt-5" *ngIf="usuario!=null">
        <div class="card-header" style="color: teal;">
            <h3 class="text-center font-weight-light my-4">{{usuario.data().nombre}}</h3>
            <p>Id: {{usuario.id}}</p>
        </div>
        <div class="card-body">
            
            <ul class="list-group">
                <li class="list-group-item" *ngIf="procesodeEditarnombreActivo">
                    <ngb-alert type="danger">
                        <strong>¿Cambiar nombre?</strong>
                        <p><small>Los datos del usuario se eliminarán</small></p>
                    </ngb-alert>
                    <p *ngIf="trabajando">
                        <ngb-alert [type]="tipodeAlerta" (close)="closeAlert()">{{ mensajeAlerta }} <span  class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></ngb-alert>
                    </p>
                    <div>
                        <input type="text"  [(ngModel)]="nombre" class="form-control" placeholder="Nombre: " (input)="validaboton()"   >
                        <button class="btn btn-primary" (click)="cancelarEditar()" style="float: left; margin-left: 4px;">Cancelar</button>
                        <button class="btn btn-danger" (click)="editarNombre(usuario.id)" style="float: right; margin-right: 4px;">Cambiar nombre</button>
                    </div>
                </li>
                <li class="list-group-item" *ngIf="!procesodeEliminarActivo">
                    <button class="btn btn-danger btn-block"  (click)="confirmaEditarNombre()">Cambiar nombre usuario</button>
                </li>
            </ul>

            <ul class="list-group">
                <li class="list-group-item" *ngIf="procesodeEliminarActivo">
                    <ngb-alert type="danger">
                        <strong>¿Eliminar usuario?</strong>
                        <p><small>Los datos del usuario se eliminarán</small></p>
                    </ngb-alert>
                    <p>
                        <ngb-alert [type]="tipodeAlerta" (close)="closeAlert()">{{ mensajeAlerta }} <span *ngIf="trabajando" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></ngb-alert>
                    </p>
                    <div>
                        <button class="btn btn-primary" (click)="cancelarEliminar()" style="float: left; margin-left: 4px;">Cancelar</button>
                        <button class="btn btn-danger" (click)="eliminarCuenta(usuario.id)" style="float: right; margin-right: 4px;">Eliminar</button>
                    </div>
                </li>
                <li class="list-group-item" *ngIf="!procesodeEliminarActivo">
                    <button class="btn btn-danger btn-block"  (click)="confirmaEliminar()">Eliminar usuario</button>
                </li>
            </ul>

            <ul class="list-group">
                <li class="list-group-item" *ngIf="procesodeAutoridadActivo">
                    <ngb-alert type="danger">
                        <strong>¿Convertir en autoridad?</strong>
                        <p><small>Seleccione regional y tipo de autoridad</small></p>
                    </ngb-alert>
                    <hr>
                    <div class="row" style="background-color: rgba#9b9a9a;" >
                        <p>1. Seleccione una regional / cuenca: - </p>
                        <div class="form-group">
                            <!-- <label for="exampleFormControlSelect1">Seleccione una regional / cuenca</label> -->
                            <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="regional" (change)="validaboton()" >
                            <option>Putumayo Norte</option>
                            <option>Putumayo Sur</option>
                            <option>VMM</option>
                            <option>VMM-otros</option>
                            <option>Administración Bog.</option>
                            <option>Llanos</option>
                            <option>Charapa</option>
                            <option>Chanangue</option>
                            <option>Iguana</option>
                            </select>
                        </div>
                    </div>
                    <hr>
                    <div class="row" style="background-color: rgba#e2e2e2;">
                        <p>2. Seleccione una o varias de las opciones de autoridad:</p>
                        <div class="col">
                          <!-- Default inline 1-->
                            <div class="custom-control custom-checkbox custom-control-inline">
                              <input type="checkbox" class="custom-control-input" id="defaultInline1" [(ngModel)]="autoridadAislante" (change)="validaboton()">
                              <label class="custom-control-label" for="defaultInline1">Autoridad aislante</label>
                            </div>
          
                            <!-- Default inline 2-->
                            <div class="custom-control custom-checkbox custom-control-inline">
                              <input type="checkbox" class="custom-control-input" id="defaultInline2" [(ngModel)]="autoridadArea" (change)="validaboton()">
                              <label class="custom-control-label" for="defaultInline2">Autoridad de área</label>
                            </div>
          
                            <!-- Default inline 3-->
                            <div class="custom-control custom-checkbox custom-control-inline">
                              <input type="checkbox" class="custom-control-input" id="defaultInline3" [(ngModel)]="autoridadAreaLocal" (change)="validaboton()">
                              <label class="custom-control-label" for="defaultInline3">Autoridad de área local</label>
                            </div>
          
                            <!-- Default inline 3-->
                            <div class="custom-control custom-checkbox custom-control-inline">
                              <input type="checkbox" class="custom-control-input" id="defaultInline4" [(ngModel)]="autoridadHSE" (change)="validaboton()">
                              <label class="custom-control-label" for="defaultInline4">Autoridad HSE</label>
                            </div>
          
                            <!-- Default inline 3-->
                            <div class="custom-control custom-checkbox custom-control-inline">
                              <input type="checkbox" class="custom-control-input" id="defaultInline5" [(ngModel)]="gerenteRegional" (change)="validaboton()">
                              <label class="custom-control-label" for="defaultInline5">Gerente regional</label>
                            </div>

                             <!-- Default inline 3-->
                             <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="defaultInline6" [(ngModel)]="auditor" (change)="validaboton()">
                                <label class="custom-control-label" for="defaultInline6">Auditor</label>
                              </div>
          
                        </div>
                      </div>

                    <p *ngIf="trabajando">
                        <ngb-alert  [type]="tipodeAlerta" (close)="closeAlert()">{{ mensajeAlerta }} <span  class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></ngb-alert>
                    </p>
                    <div>
                        <button class="btn btn-primary" (click)="cancelarPromover()" style="float: left; margin-left: 4px;">Cancelar</button>
                        <button class="btn btn-danger" (click)="PromoverAautoridad(usuario)" style="float: right; margin-right: 4px;" [disabled]="botondisabled">Convertir en autoridad</button>
                    </div>
                </li>
                <li class="list-group-item" *ngIf="!procesodeAutoridadActivo">
                    <button class="btn btn-danger btn-block"  (click)="confirmaPromover()" >Converir en autoridad</button>
                </li>
            </ul>
           
        </div>
        <div class="card-footer text-center">
           <button class="btn btn-primary  btn-block" (click)="cerrar(null)">Cerrar</button>
        </div>
    </div>
</div>